import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { AgentPublicBio } from "model/agent";
import * as styles from "../styles";

interface Props {
	publicBio: AgentPublicBio;
	onAddTestimonial: () => void;
	onEditTestimonial: (index: number) => void;
	onDeleteTestimonial: (index: number) => void;
}

export const TestimonialsSection: React.FC<Props> = ({
	publicBio,
	onAddTestimonial,
	onEditTestimonial,
	onDeleteTestimonial,
}) => {
	const testimonials = publicBio.testimonials ?? [];

	return (
		<>
			{/* Title row + table share one grid item so the gap is a fixed 16px (Figma, MAX-3868),
			    not the 24px the parent Grid spacing would otherwise impose between them. */}
			<Mui.Grid item xs={12}>
				<Mui.Box
					display="flex"
					justifyContent="space-between"
					alignItems="center"
					style={{ marginBottom: 16 }}
				>
					<Mui.Typography style={{ ...styles.sectionTitle, marginBottom: 0 }}>
						Testimonials
					</Mui.Typography>
					<Mui.Button
						variant="text"
						onClick={onAddTestimonial}
						startIcon={<Icons.Plus size={16} />}
						style={styles.uploadButtonTertiary}
					>
						Add Testimonial
					</Mui.Button>
				</Mui.Box>
				<table style={styles.testimonialsTable}>
					<thead>
						<tr>
							<th style={{ ...styles.testimonialsHeaderCell, borderLeft: "1px solid #DDE7E8", borderTopLeftRadius: 8 }}>
								Testimonial
							</th>
							<th style={{ ...styles.testimonialsHeaderCell, borderRight: "1px solid #DDE7E8", borderTopRightRadius: 8 }}>
								Client
							</th>
						</tr>
					</thead>
					<tbody>
						{testimonials.length === 0 ? (
							<tr>
								<td
									style={{ ...styles.testimonialsEmptyCell, borderLeft: "1px solid #DDE7E8", borderBottomLeftRadius: 8 }}
								>
									No testimonials added yet!
								</td>
								<td
									style={{ ...styles.testimonialsBodyCell, borderRight: "1px solid #DDE7E8", borderBottomRightRadius: 8 }}
								/>
							</tr>
						) : (
							testimonials.map((testimonial, index) => {
								const isLast = index === testimonials.length - 1;
								return (
									<tr key={index}>
										<td
											style={{
												...styles.testimonialsBodyCell,
												borderLeft: "1px solid #DDE7E8",
												...(isLast ? { borderBottomLeftRadius: 8 } : {}),
											}}
										>
											{testimonial.quote}
										</td>
										<td
											style={{
												...styles.testimonialsBodyCell,
												borderRight: "1px solid #DDE7E8",
												...(isLast ? { borderBottomRightRadius: 8 } : {}),
											}}
										>
											<div style={styles.clientCellContent}>
												<span>{testimonial.author}</span>
												<span style={styles.testimonialActions}>
													<span
														role="button"
														aria-label="Edit testimonial"
														style={styles.testimonialActionIcon}
														onClick={() => onEditTestimonial(index)}
													>
														<Icons.Edit2 size={16} />
													</span>
													<span
														role="button"
														aria-label="Delete testimonial"
														style={styles.testimonialActionIcon}
														onClick={() => onDeleteTestimonial(index)}
													>
														<Icons.Trash2 size={16} />
													</span>
												</span>
											</div>
										</td>
									</tr>
								);
							})
						)}
					</tbody>
				</table>
			</Mui.Grid>
		</>
	);
};
